/* eslint-disable */
export default {
  customer: {
    TEST_IM: '11111',
    '0001000140': 'Aardappelhandel De Rop N.V.',
    '0001000148': 'Adam Theis GmbH',
    ADM2000051: 'Administrative',
    'FI.2000017': 'Agricola Jaifam S.L.U:',
    'RE.2000018': 'Agro Verduras 2000, S.L.',
    '0001000089': 'Albert Heijn B.V.',
    '0001000012': 'Aldi Erpe-Mere',
    '0001000014': 'Aldi Hamburg',
    '0001000050': 'ALDI Head Office Germany',
    '0001000025': 'ALDI Hoodkantoor (Rebate)',
    '0001000016': 'Aldi Munchen',
    '0001000010': 'Aldi Roeselare',
    '0001000051': 'Aldi Spain',
    '0001000015': 'Aldi Stuttgart',
    SL_ES11: 'Almer#a',
    '0001000135': 'ARC Eurobanan, S.L.-Madrid -NL-',
    '0001000107': 'Aviko',
    '0001000124': 'Axel Meyer - Landwirtschaft',
    '0001000008': 'Azienda Agricola',
    '0001000065': 'Bakker AGF',
    '0001000019': 'Bakker Centrale Inkoop  B.V.',
    '0001000152': 'Bakker Centrale Inkoop  B.V.',
    SL_ES12: 'Barcelona',
    SL_ES18: 'Barcelona 1',
    SL_NL11: 'Barendrecht',
    '0001000005': 'Beegdenhof, tui - 60204',
    V300106: 'Bekuplast GmbH',
    '0001000036': 'Belgische Fruitveiling C.V.',
    '0001000153': 'Belgische Fruitveiling C.V.',
    '0001000070': 'Belgium Second Hand Buyer [SHB/32]',
    '0001000080': 'BelOrta cvba',
    '0001000116': 'Betagrande, S.L.',
    '0001000110': 'Bialski Owoc Sp. z o.o.',
    SL_ES13: 'Bilbao',
    '0001000144': 'BIMARO Sp. z o.o.',
    '0001000145': 'Bio Freshi Produce B.V.',
    SL_NL12: 'Bleiswijk',
    SL_NL18: 'Bleiswijk (Hab#)',
    '0001000092': 'Boni Supermarkt',
    '0001000167': 'Boni Supermarkt',
    '0001000159': 'Boon Sliedrecht B.V.',
    '0001000031': 'Borgloon (BelOrta)',
    SL_DE17: 'Bornheim',
    SL_NL13: 'Breda',
    '0001000017': 'Carrefour Belgium N.V. / S.A.',
    '0001000119': 'Carrefour Belgium N.V. / S.A.',
    '0001000122': 'Carrefour Belgium N.V. / S.A.',
    CSK2000048: 'Collective Stock Known',
    '0001000022': 'collective stock unknow',
    '0001000021': 'Collective Stock Unknown',
    CSU2000047: 'Collective Stock Unknown',
    '0001000186': 'Collective stock unknown Belgium',
    '0001000187': 'Collective stock unknown Central',
    '0001000138': 'Consum Plataforma Barcelona',
    '0001000139': 'Consum Plataforma Murcia',
    '0001000137': 'Consum Plataforma Valencia',
    '0001000136': 'Consum Sociedad Coop. Valenciana',
    '0001000090': 'Coop Groothandel B.V.',
    '0001000146': 'Coop Groothandel B.V.',
    '0001000011': 'Cust. Hierarchy test1',
    '0001000013': 'Customer National Hierarchy3',
    '0001000056': 'De heer Payment',
    '0001000087': 'Deen Distributie B.V.',
    '0001000163': 'Deen Distributie B.V.',
    '0001000002': 'Delhaize Ets.',
    'FI.2000030': 'Delhaize Ets.',
    'RE.2000009': 'Delhaize Ets.',
    'RE.2000016': 'Delhaize Ets.',
    '0001000029': 'Delhaize Le Lion/De Leeuw',
    '0001000150': 'Delhaize Le Lion/De Leeuw',
    DCP2000046: 'Departure Consolidation Point',
    '0001000033': 'Destroyed in Operations 3rd party B',
    '0001000032': 'Destroyed in Operations Central',
    '0001000035': 'Destructor of Washing Machines',
    '0001000096': 'Detailresult Services B.V.',
    '0001000164': 'Detailresult Services B.V.',
    SL_DE12: 'Dortmund',
    '0001000205': 'Dummy Customer - Z001 - 01',
    DUMMY1: 'Dummy customer ETM',
    '0001000198': 'Dummy Sold-to - / REC - 003',
    '0001000206': 'Dummy Sold-to - Z001 - 02',
    '0001000207': 'Dummy Sold-to - Z001 - 03',
    '0001000106': 'Eco Veg BVBA',
    '0001000030': 'EDEKA FK Nord 161612',
    'RE.2000007': 'EDEKA FK Nord 161612',
    'RE.2000014': 'EDEKA FK Nord 161612',
    '0001000149': 'EDEKA Handelsgesellschaft',
    '0001000127': 'EDEKA Handelsgesellschaft Nord mbH',
    '0001000125': 'EDEKA HandelsgesellschaftNordbayern',
    '0001000126': 'EDEKA HandelsgesellschaftNordbayern',
    SL_DE19: 'Eriskirch',
    '0001000117': 'Exportaciones Ciscar, S.L.',
    'FI.2000003': 'Frito Lay',
    'FI.2000010': 'Frito Lay',
    '0001000123': 'Frutania GmbH',
    '0001000112': "G's Marketing Central Europe s.r.o.",
    SL_NL16: 'Geldermalsen',
    '0001000113': 'Globus CR, k.s.',
    '0001000160': 'Goldstein Agrarhandelsgesellschaft',
    SL_CO11: 'Grobbendonk',
    '0001000086': 'Groda AGF B.V.',
    'FI.2000004': 'Groentekwekerij De Vries B.V.',
    'FI.2000011': 'Groentekwekerij De Vries B.V.',
    SL_BE14: 'Halle (Colruyt)',
    SL_DE14: 'Hamm',
    SL_DE18: 'Hannover',
    SL_NL19: 'Heerenveen (Hab#)',
    '0001000128': 'Heilmann AG',
    '0001000155': 'Hessing Zwaagdijk B.V.',
    '0001000094': 'Hollander Barendrecht B.V.',
    '0001000114': 'Hollander Barendrecht B.V.',
    SL_BE13: 'Hoogstraten',
    '0001000091': 'Hoogvliet',
    '0001000156': 'Hoogvliet B.V.',
    '0001000157': 'Hoogvliet B.V.',
    SL_ES16: 'Ibiza',
    SL_NL15: 'IJsselmuiden',
    '0001000162': 'Jan Linders B..V.',
    '0001000052': 'Jansen',
    '0001000006': 'Janssen Agro Plant - 630010',
    '0001000154': 'Jumbo Supermarkten B.V.',
    '0001000085': 'Jumbo Supermarkten Holding B.V.',
    '0001000060': 'Jumbo Utrecht',
    SL_BE11: 'Katelijne',
    '0001000009': 'Kaufland Ceská republika v.o.s. DC',
    'RE.2000044': 'Kaufland Ceská republika v.o.s. DC',
    '0001000141': 'Kaufland Polska Markety',
    '0001000142': 'Kaufland Polska Markety',
    '0001000000': 'Kimco N.V.',
    '0001000020': 'Kimco N.V.',
    '0001000023': 'Kimco N.V.',
    'FI.2000035': 'Kimco N.V.',
    '0001000188': 'Loss Assumed (CO)',
    SL_DE16: 'M#nchen',
    SL_ES14: 'Madrid',
    SL_DE15: 'Magdeburg',
    '0001000003': 'Maison Amoroso S.A.',
    'FI.2000038': 'Maison Amoroso S.A.',
    '0001000161': 'Makro N.V.',
    SL_ES15: 'Mallorca',
    '0001000004': 'McCain Foods Europe B.V.',
    '0001000111': 'MT POL Sp. z o.o.',
    SL_ES22: 'Murcia',
    SL_ES19: 'Murcia Consum',
    SL_DE13: 'Mutterstadt',
    '0001000018': 'N.V. Etn. Franz COLRUYT',
    '0001000151': 'N.V. Etn. Franz COLRUYT',
    'RE.2000006': 'Netto Coswig',
    'RE.2000013': 'Netto Coswig',
    'RE.2000031': 'Netto Coswig',
    '0001000130': 'Norbert Pesch GbR',
    NNR2000050: 'Not Network Related',
    '0001000095': 'O. Smeding & Zn. B.V.',
    '0001000158': 'O. Smeding & Zn. B.V.',
    'FI.2000005': 'Obstbauer Wedeking UG',
    'FI.2000012': 'Obstbauer Wedeking UG',
    '0001000121': 'Peka Kroef - IMP',
    '0001000129': 'Peka Kroef B.V.',
    '0001000147': 'Peka Kroef B.V.',
    '0001000088': 'Poiesz Supermarkten B.V.',
    '0001000001': 'Pomuni Trade',
    '0001000041': 'Pomuni Trade',
    '0001000115': 'Pomuni Trade',
    '0001000040': 'Pomuni Trade (NEW)',
    '0001000055': 'Pomuni Trade (NEW)',
    '0001000027': 'Pomuni Trade 1000027',
    '0001000028': 'Pomuni Trade 1000028',
    PC2000045: 'Pool Counter',
    '0001000071': 'Pool Counter Lost [LOS/33]',
    '0001000171': 'Pool Stock Unknown',
    '0001000172': 'Pool Stock Unknown',
    '0001000173': 'Pool Stock Unknown',
    SL_BE12: 'Roeselare',
    '0001000024': 'RTI Destructor',
    'WA.2000025': 'RTI Destructor',
    '0001000007': 'SAN PIETRO s.r.l.',
    '0001000026': 'SAN PIETRO s.r.l.',
    '0001000170': 'Scherpenhuizen B.V.',
    SH2000033: 'Second Hand buyer',
    '0001000039': 'Settle Stock Differences by 3rd par',
    '0001000038': 'Settle Stock Differences by EPS BE',
    STD2000049: 'Stock Differences',
    '0001000034': 'Stock Differences Katelijne',
    '0001000037': 'Stock Differences Pomuni',
    'RE.2000008': 'Super Groente- en Fruitmarkt B.V.',
    'RE.2000015': 'Super Groente- en Fruitmarkt B.V.',
    'RE.2000052': 'Super Groente- en Fruitmarkt B.V.',
    '0001000143': 'TESCO POLSKA SP. Z.O.O.',
    '0001000045': 'Test Credit Check',
    '0001000105': 'Test DE',
    '0001000175': 'Test GS01',
    '0001000176': 'Test GS02',
    '0001000177': 'Test GS03',
    '0001000178': 'Test GS04',
    '0001000179': 'Test GS05',
    '0001000180': 'Test GS06',
    '0001000181': 'Test GS07',
    '0001000185': 'Test GS08',
    T_IM_NL11: 'Test Jelle',
    T_IM: 'Test JJE IM upload',
    T_IM_BE16: 'Test JJE IM upload',
    T_IM_BE17: 'Test JJE IM upload',
    T_SL: 'Test JJE SL upload',
    T_SL_BE16: 'Test JJE SL upload',
    T_SL_BE17: 'Test JJE SL upload',
    '0001000194': 'Test klant geen Company code',
    '0001000196': 'Test klant geen Sales org',
    '0001000195': 'Test klant2 geen Company code',
    '0001000193': 'Test Retailer changed',
    '0001000190': 'Test Supermarkt',
    '0001000191': 'Test Supermarkt2',
    '0001000192': 'Test Supermarkt3',
    'FI.2000032': 'test voor Spanje',
    '0001000075': 'TESTJDA',
    '0001000076': 'TESTJDA CSU BE',
    '0001000118': 'Testklant EROSKI',
    '0001000166': 'The Greenery C.T.L.',
    TR2000034: 'Transporter A',
    SL_ES21: 'Valencia',
    SL_ES17: 'Valencia Consum',
    '0001000120': 'Van Vugt Kruiden VOF',
    SL_NL17: 'Venlo',
    '0001000100': 'Vicente Giner S.A.',
    '0001000093': 'Vomar Voordeelmarkt B.V.',
    '0001000165': 'Vomar Voordeelmarkt B.V.',
    SL_NL14: 'Wervershoof',
    SL_ES20: 'Zaragoza',
    SL_BE15: 'Zellik Delhaize',
  },
  salesOrganisation: {
    '1000': 'Dom. Sales Org',
    '1010': 'Dom. Sales Org 2',
    AT10: 'EPS AT GmbH Austria',
    BE10: 'EPS Belgium B.V.B.A.',
    CZ10: 'EPS CZ s.r.o.',
    DK10: 'EPS Denmark',
    AO00: 'EPS España-Overseas',
    FR10: 'EPS France SARL',
    DE10: 'EPS Germany GmbH',
    HU10: 'EPS Hungary Kft.',
    AC00: 'EPS Int - AOC',
    AE00: 'EPS Int - AOE',
    AS00: 'EPS Int - AOS',
    AW00: 'EPS Int - AW',
    CO00: 'EPS Int - CO',
    IT10: 'EPS Italy S.r.l.',
    NL10: 'EPS Netherlands B.V.',
    PL10: 'EPS Poland Sp.z.o.o.',
    SK10: 'EPS Slovakia s.r.o.',
    ES10: 'EPS Spain S.L. Unip',
    TR10: 'EPS Turkey',
    UK10: 'EPS UK Limited',
    '1100': 'Int. Sales Org',
    '1110': 'Int. Sales Org 2',
    '0001': 'Sales Org. 001',
  },
  role: {
    FIN: 'Finance (invoice retrieval)',
    OWNER: 'Owner',
    COMP: 'Tray management complete',
    TRMC_RO: 'Tray management complete read-only',
    TMF_BAS: 'Tray management flows (basics)',
    TMF_MED: 'Tray management flows (medium)',
    TMF_PRO: 'Tray management flows (pro)',
    TMF_RO: 'Tray management flows (read-only)',
    TMO_BAS: 'Tray management ordering (basic)',
    TMO_MED: 'Tray management ordering (medium)',
    TMO_PRO: 'Tray management ordering (pro)',
    TMO_RO: 'Tray management ordering (read-only)',
  },
  language: {
    BG: 'Bulgarian',
    CS: 'Czech',
    DA: 'Danish',
    NL: 'Dutch',
    EN: 'English',
    FR: 'French',
    DE: 'German',
    EL: 'Greek',
    HU: 'Hungarian',
    IT: 'Italian',
    PL: 'Polish',
    PT: 'Portuguese',
    RO: 'Romanian',
    SK: 'Slovak',
    ES: 'Spanish',
    TR: 'Turkish',
    UK: 'Ukrainian',
  },
};
